import { render, staticRenderFns } from "./MbDictionaryApiSelect.vue?vue&type=template&id=1b913583&"
import script from "./MbDictionaryApiSelect.vue?vue&type=script&lang=js&"
export * from "./MbDictionaryApiSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports